import styled from 'styled-components';

export const NextImageStyleCover = styled.div`
  position: relative;
  width: 100%;
  background-size: contain;
  background-image: url('https://images.myloapp.in/NestJsUploads/1701860785118-1668581912764-defaultimage-(1).webp');
  padding-top: ${(props) => props.imageRatioMobile || '100%'};
  .desktop_image {
    display: none !important;
  }
  .mobile_image {
    display: block !important;
  }
  @media (min-width: 720px) {
    padding-top: ${(props) => props.imageRatioDesktop || '100%'};
    .mobile_image {
      display: none !important;
    }
    .desktop_image {
      display: block !important;
    }
  }
`;

export const NextImageStyleCoverProduct = styled.div`
  position: relative;
  width: 100%;
  .desktop_image {
    display: none !important;
  }
  .mobile_image {
    display: block !important;
  }
  img {
    position: unset !important;
    width: 100% !important;
    height: 100% !important;
  }
  span {
    position: unset !important;
  }
  @media (min-width: 720px) {
    .mobile_image {
      display: none !important;
    }
    .desktop_image {
      display: block !important;
    }
  }
`;
